import produce from "immer";
import { reject } from "lodash";
import { getType } from "typesafe-actions";
import { Panel } from "@radarly/models/panel";
import { Action, Actions } from "./action";

const INITIAL_STATE = [];

export default function reducer(
  state: Panel[] = INITIAL_STATE,
  action: Actions
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case getType(Action.panelClosed):
        if (!action.payload.type) {
          draft.shift();
        } else {
          return reject(draft, {
            type: action.payload.type,
          });
        }
        break;
      case getType(Action.panelOpened):
        draft.push(action.payload);
        break;
      case getType(Action.panelsClosed):
        return INITIAL_STATE;
      default:
        return state;
    }
  });
}
